module.exports = __webpack_public_path__ + "static/media/icon_tools.3fd8a68a.svg";